import { useState } from "react";
import LeaveRequestDialog from "./AddLeave";

export default function UserLeaveRequest({
  leaves,
  handleDeny,
  handleApprove,
  getUserInfo,
  userID,
}) {
  const [open, setOpen] = useState(false);

  const calcDuration = (startISO, endISO) => {
    if (!startISO || !endISO) return "";

    const start = new Date(startISO);
    const end = new Date(endISO);

    const diffMs = end - start; // difference in milliseconds
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    if (diffHours !== 0 && diffMinutes !== 0)
      return `${diffHours}h ${diffMinutes}m`;
    if (diffHours === 0) return `${diffMinutes}m`;
    if (diffMinutes === 0) return `${diffHours}h`;
  };

  return (
    <div className="p-6">
      <LeaveRequestDialog
        open={open}
        userID={userID}
        setOpen={setOpen}
        getUserInfo={getUserInfo}
      />

      {/* Work Details Card */}
      <section className="bg-white mb-16">
        <div className="flex items-center justify-between  mb-4">
          <h2 className="text-gray-800 font-semibold text-lg">
            Leave Requests
          </h2>
          <button
            onClick={() => setOpen(true)}
            className="bg-gray-500 hover:bg-gray-600 text-white px-3 py-1 rounded"
          >
            Add Leave Request
          </button>
        </div>
        <hr className="w-full mb-2 mt-2" />

        {leaves?.map((leave) => {
          const leaveType = leave.type;

          // Format date range: e.g. "Mon 13 May 2025 → Wed 15 May 2025"
          const formattedStart = leave.startTime.slice(0, 16).replace("T", " ");
          const formattedEnd = leave.endTime.slice(0, 16).replace("T", " ");

          // Format duration in hours with one decimal place
          const durationHours = calcDuration(formattedStart, formattedEnd);

          // Map status to badge colors (example)
          const statusColors = {
            pending: "bg-orange-100 text-orange-800",
            approved: "bg-green-100 text-green-800",
            rejected: "bg-red-100 text-red-800",
          };

          const badgeColor =
            statusColors[leave.status] || "bg-gray-100 text-gray-600";

          // Capitalize status text
          const statusText = leave.status
            ? leave.status.toUpperCase()
            : "UNKNOWN";

          return (
            <div
              key={leave._id}
              className="bg-gray-50 p-4 relative w-full mb-4 rounded shadow"
            >
              {/* Approve button - top right */}
              {!leave.approved && leave.status !== "rejected" && (
                <div className="absolute top-3 right-3 flex gap-2">
                  <button
                    onClick={() => handleApprove(leave._id)}
                    className="bg-green-500 hover:bg-green-600 text-white text-xs font-semibold px-3 py-1 rounded"
                  >
                    Approve
                  </button>
                  <button
                    onClick={() => handleDeny(leave._id)} // Make sure to define handleReject
                    className="bg-red-500 hover:bg-red-600 text-white text-xs font-semibold px-3 py-1 rounded"
                  >
                    Reject
                  </button>
                </div>
              )}

              <h3 className="text-gray-800 font-semibold mb-2">
                {leave.reason || "Leave Request"}{" "}
                <span className="text-sm text-gray-600">({durationHours})</span>
              </h3>
              <p className="text-gray-700 text-sm mb-2">{leaveType}</p>
              <p className="text-gray-700 text-sm mb-2">
                {formattedStart} &rarr; {formattedEnd}
              </p>

              <div
                className={`absolute bottom-3 right-3 rounded-full px-3 py-1 text-xs font-semibold shadow-sm ${badgeColor}`}
              >
                {statusText}
              </div>
            </div>
          );
        })}
      </section>
    </div>
  );
}
